import { OptionContainer } from "src/components/Renderer/OptionContainer";
import { Toggle } from "@memento/ui/Form/Toggle";
type ToggleBlockProps = {
  label: string;
  checked?: boolean;
  onChange: (enabled: boolean) => void;
};

export function ToggleBlock({ label, checked, onChange }: ToggleBlockProps) {
  return (
    <div className="flex flex-col gap-3 text-sm text-muted">
      <OptionContainer
        label={label}
        className="rounded-md bg-gray-200 p-3 text-gray-50"
      >
        <Toggle checked={checked} onChange={onChange} />
      </OptionContainer>
    </div>
  );
}
